import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Catégorie d'offre: ", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Titre :", -1)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "Description :", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "Salaire :", -1)
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Date de publication :", -1)
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "Date d'expiration:", -1)
const _hoisted_22 = { key: 6 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Commune :", -1)
const _hoisted_24 = { key: 7 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Activité :", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-offres",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              (_ctx.offre?.categorieOffre)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.categorieOffre?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.titre)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.titre), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.description)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.description), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.salaire)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.salaire), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.datePublication)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_Date( _ctx.offre?.datePublication)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.dateExpiration)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.offre?.dateExpiration)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.commune)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.commune?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offre?.activite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("td", null, _toDisplayString(_ctx.offre?.activite?.libelle), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}